import React from "react";
import { useNavigate } from "react-router-dom";
import HomeHeader from "../home/new/components/homeHeader";
import "./NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      <HomeHeader
        title=""
        isTitle={false}
        navItems={true}
        headerColor="header-white"
      />
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-description">
          Oops! The page you're looking for seems to have vanished into thin
          air.
        </p>
        <button className="not-found-button" onClick={() => navigate("/")}>
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
